// 配置生产环境跟测试环境的区分
// 路由的模式

const routerMode = 'hash';
let routerbase = '/alc/logincenter/';
let baseUrl = process.env.baseUrl;
console.log(process.env.bindSuccess)
if(process.env.NODE_ENV == 'production'){
    routerbase = '/alc/logincenter/';
}
export {
    routerMode,
    baseUrl,
    routerbase,
}


// WEBPACK FOOTER //
// ./src/config/env.js